<div class="row pesquisaContainer" id="pesquisaContainer">
  <div class="col-md-12 my-2">
    <div class="card">
      <h5 class="card-header"><i class="bi bi-person-bounding-box me-2"></i>Dados Pessoais</h5>
      <div class="card-body">
        <div class="row">
          <div class="col-2 text-center">
            <div class="p-4">
              <profile-picture class="profilePicture" [url]="user?.url_foto" [size]="80"></profile-picture>
            </div>
          </div>
          <div class="col-10">
            <div class="row my-2">
              <div class="col-md-12">
                <strong>{{entidade?.sigla || ""}} {{(user?.apelido)?.toUpperCase() || "Sem informação"}}</strong>
              </div>
            </div>
            <div class="row my-2">
              <div class="col-md-6">
                <strong>Email</strong><br>
                {{user?.email || "Sem email"}}
              </div>
              <div class="col-md-3">
                <strong>Telefone</strong><br>
                {{user?.telefone || "Sem telefone"}}
              </div>
              <div class="col-md-3">
                <strong>Situação funcional</strong><br>
                {{lookup.getValue(lookup.USUARIO_SITUACAO_FUNCIONAL, user?.situacao_funcional) || "Não informado"}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
